/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { ReferralsApi } from "@/api/referrals";
import { DataProvider } from "react-admin";
import { ResourceName } from "../react-admin.util";

const dataProvider: DataProvider = {
  getList: async (_, params) => {
    const { pagination, filter } = params;

    const users = await ReferralsApi.getReferralUsers({
      ...filter,
      page: pagination?.page,
      perPage: pagination?.perPage,
    });

    return { data: users.data, total: users.meta.total };
  },
  getMany: () => {
    return new Promise((res) => res);
  },
  getOne: async () => {
    return new Promise((res) => res);
  },
  create: () => {
    return new Promise((res) => res);
  },
  update: () => {
    return new Promise((res) => res);
  },
  updateMany: () => {
    return new Promise((res) => res);
  },
  delete: () => {
    return new Promise((res) => res);
  },
  deleteMany: () => {
    return new Promise((res) => res);
  },
  getManyReference: () => {
    return new Promise((res) => res);
  },
};

export const referralUsersResourceProvider = {
  resource: ResourceName.REFERRAL_USERS,
  dataProvider,
};
